import { API_BASE_URL } from "src/config/apiBase";
import React, { useState, useEffect } from "react";
import { decryptToken } from "../utils/getToken";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import { useNavigate } from "react-router-dom";
import { isInFilter } from "../utils/dateFilter";

// ✅ Status badge styles
const STATUS_STYLES = {
    Pending: "bg-yellow-200 text-yellow-700",
    Processing: "bg-blue-200 text-blue-700",
    Packed: "bg-purple-200 text-purple-700",
    Shipped: "bg-indigo-200 text-indigo-700",
    "Out for Delivery": "bg-orange-200 text-orange-700",
    Delivered: "bg-green-200 text-green-700",
    Cancelled: "bg-red-200 text-red-700",
};

export default function OrderSummary({filter}) {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const url = API_BASE_URL;
    const token = decryptToken("accessToken") || "";
    const user = getDecryptedUserFromCookie("gta_mainstateuser");
    const navigate = useNavigate()

    const fetchOrders = async () => {
        try {
            const res = await fetch(`${url}/payment/adminorder`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            const data = await res.json();
            console.log("🔥 Raw Order Response:", data);

            setOrders(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error("❌ Fetch orders failed:", error);
        } finally {
            setLoading(false);
        }
    };

    const filteredOrders = orders.filter(o =>
        isInFilter(o.createdAt || o.updatedAt, filter)
    );


    useEffect(() => {
        if (token) fetchOrders();
    }, [token]);

    return (
        <div>
            <div className="flex justify-between gap-2 items-center mb-3">
                <h2 className="text-[20px] font-bold text-[#222] ">
                    Order Summary
                </h2>
                <button
                    onClick={() => navigate('/orders')}
                    className="text-xs px-2 py-1 border border-blue-600 text-blue-600 rounded-md hover:bg-blue-600 hover:text-white transition">
                    View more
                </button>
            </div>

            <div className="bg-gray-50 rounded p-2 min-h-[120px] flex items-center justify-center w-full min-w-0">
                {loading ? (
                    <p className="text-gray-500 text-sm animate-pulse">
                        Loading orders...
                    </p>
                ) : filteredOrders.length === 0 ? (
                    <p className="text-gray-500 text-sm">No orders found.</p>
                ) : (
                    <div className="w-full overflow-x-auto">
                        <table className="w-full text-sm min-w-[420px]">
                        <thead className="font-semibold text-gray-700">
                            <tr>
                                <th className="text-left py-1">Product</th>
                                <th className="text-left py-1">Price</th>
                                <th className="text-center py-1">Status</th>
                            </tr>
                        </thead>

                        <tbody>
                            {filteredOrders.slice(0, 9).map((order, index) => {
                                let productList = [];

                                try {
                                    productList = typeof order.cart_products === "string"
                                        ? JSON.parse(order.cart_products)
                                        : order.cart_products || [];
                                } catch (e) {
                                    console.error("Invalid cart_products:", e);
                                }

                                const firstProduct = productList[0]?.product_name || "Unknown Product";
                                const extraCount = productList.length - 1;

                                const displayedProduct =
                                    extraCount > 0
                                        ? `${firstProduct} +${extraCount}`
                                        : firstProduct;

                                const price = Number(order.amountafterdiscount || 0)
                                    .toLocaleString("en-IN", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                    });

                                return (
                                    <tr key={index} className="border-t">
                                        <td className="py-2 text-gray-700 max-w-[180px] truncate">
                                            {displayedProduct}
                                        </td>

                                        <td className="py-2 text-left text-gray-800">
                                            ₹{price}
                                        </td>

                                        <td className="py-2 text-center">
                                            <span
                                                className={`px-2 py-1 rounded-full text-xs font-medium ${STATUS_STYLES[order.orderStatus] ||
                                                    "bg-gray-200 text-gray-700"
                                                    }`}
                                            >
                                                {order.orderStatus}
                                            </span>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                    </div>
                )}
            </div>
        </div>
    );
}
